import { useParams } from 'react-router-dom';

/** Как на витрине: /merchant/order/{id} (сервис задаётся поддоменом, не путём). */
const MERCHANT_ORDER = '/merchant/order';

export function buildPaymentPaths(pageCode, uniqueId) {
  const pc = pageCode != null ? String(pageCode).trim() : '';
  const uid = uniqueId != null ? String(uniqueId).trim() : '';

  const mo = (code) => `${MERCHANT_ORDER}/${code}`;

  return {
    toIndex2: () => {
      if (pc) return `${mo(pc)}/index2`;
      if (uid) return `/${uid}/index2`;
      return '/index2';
    },
    toPage: () => (pc ? mo(pc) : '/'),
    toSuccess: () => (pc ? `${mo(pc)}/success` : '/'),
    toRefund: () => (pc ? `${mo(pc)}/refund` : '/'),
  };
}

/**
 * @param {string} [overridePageCode] — например page?.page_code
 * @param {string} [overrideUniqueId]
 */
export function usePaymentPaths(overridePageCode, overrideUniqueId) {
  const params = useParams();

  const pageCode =
    overridePageCode !== undefined && overridePageCode !== null
      ? String(overridePageCode).trim()
      : (params.pageCode || '').trim();

  const uniqueId =
    overrideUniqueId !== undefined && overrideUniqueId !== null
      ? String(overrideUniqueId).trim()
      : (params.uniqueId || '').trim();

  return buildPaymentPaths(pageCode, uniqueId);
}
